<script lang="ts">
  import api from '../api/api'
  import {lang} from '../i18n'

  export let handle: string

  type PageType = {
    id: string
    translations: Record<string, any>
  }

  let page: PageType | undefined

  $: if (handle) fetchPageData(handle)

  async function fetchPageData(handle: string) {
    page = await api.get(`/pages/${handle}`)
    window.scrollTo({top: 0})
  }
</script>

{#if page}
  <div class="row">
    <div class="simple_block">
      <h1>{page.translations[lang ?? '']?.title ?? ''}</h1>
      <div class="simple__content">
        <div class="about-text">
          {@html page.translations[lang ?? '']?.content ?? ''}
        </div>
      </div>
    </div>
  </div>
{/if}
